import { cn } from '@/lib/utils'

interface LogoProps {
  className?: string
  showText?: boolean
  iconClassName?: string
  labelClassName?: string
  label?: string
}

export function Logo({
  className,
  showText = true,
  iconClassName,
  labelClassName,
  label = "8ball",
}: LogoProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <svg
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('h-10 w-10 aspect-square', iconClassName)}
      >
        {/* RFID Ring */}
        <circle
          cx="50"
          cy="50"
          r="48"
          stroke="hsl(var(--primary))"
          strokeWidth="4"
        />
        
        {/* Black Ball */}
        <circle cx="50" cy="50" r="42" fill="black" />
        
        {/* White Inner Circle */}
        <circle cx="50" cy="50" r="24" fill="white" />
        
        {/* Number 8 */}
        <text
          x="50"
          y="50"
          textAnchor="middle"
          dy=".35em"
          fill="black"
          fontSize="32"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          8
        </text>
        
        {/* Gloss/Shine Effect */}
        <path
          d="M25 25 C 25 25, 40 15, 60 20"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          opacity="0.3"
        />
      </svg>
      {showText && (
        <span className={cn('font-bold tracking-tight', labelClassName ?? 'text-xl')}>
          {label}
        </span>
      )}
    </div>
  )
}
